<template>
  <div class="imgCollectList">
    <!-- 二维码 -->
    <common-qr-code
      :qrCodeType="qrCodeType"
      @finishScan="finishScan"
      :isImgStyle="true"
      :imgStyleText="imgStyleText"
      :isDisabled="isDisabled"
    ></common-qr-code>
    <div class="collectContent" style="min-height: 7rem">
      <div class="tabs" v-if="isShowNav">
        <div class="tab" :class="{ on: tabIndex === 0 }" @click="tabIndex = 0">
          影像补传
        </div>
        <div class="tab" :class="{ on: tabIndex === 1 }" @click="tabIndex = 1">
          签名盖章表单
        </div>
        <div class="tab quickAdd" v-show="tabIndex == '1'" @click="openQuickCollect">
          <Icon type="ios-cloud-upload" />
          <span>批量上传</span>
        </div>
      </div>
      <uploadImg
        class="uploadContent"
        ref="uploadContent"
        :mergeImgClsArr="mergeImgClsArr"
        :uploadImgItems="currentImgArr"
        :maxApptStatus="maxApptStatus"
        :isQuickCollectFlag.sync="isQuickCollectFlag"
        :isDisabled="isDisabled"
        :isShowNav="isShowNav"
        @submitImg="submitImg"
        @removeImg="removeImg"
        @getImgSrc="getImgSrc"
        @initPage="initPage"
        v-if="initFinish"
      ></uploadImg>
    </div>
    <send-message v-if="riskUpdateFlag" :riskModel="riskUpdateFlag" :MOBILE_TEL="MOBILE_TEL"></send-message>
    <div class="fixed_btn operator-footer-btn-group">
      <el-row :gutter="20" type="flex" justify="center">
          <el-button @click="goPrev" class="button light-button prev" id="formPrintPrevBtn" v-if="isShowPrev">上一步</el-button>
          <el-button @click="skipToNext" class="button save next" id="formPrintPrevBtn" v-if="apptStatus>=4&&imgType!=='uploadForm'">下一步</el-button>
          <el-button @click="submit" class="button save next" id="formPrintPrevBtn" v-if="(imgType == 'uploadImg' && apptStatus < 4 && apptStatus != 2) || (imgType == 'uploadForm' && (apptStatus < 11 || apptStatus == 12))">提交审核</el-button>
          <!-- <el-button class="skip" @click="skipToNext" v-if="isTest=='1'">跳过（仅测试用）</el-button> -->
      </el-row>
    </div>
  </div>
</template>

<script>
import flowTip from "@/components/common/flowTip";
import { imgCommonMixins } from "./child/imgCommonMixins";
import oppService from "@/service/opp-service";
import commonQrCode from "./child/common-qrcode";
import uploadImg from "./upload-img";
import sendMessage from "./child/sendMessage";
import date from "@/tools/date";
import {saveKidmImgclsCollectFlag, saveAgreement} from "@/service/image-service";
export default {
  data () {
    return {
      imgStyleText: "请拍摄上传以下开户所需的影像材料:",
      ocrIImgtems: [], //ocr识别采集
      faceImgItems: [], //免冠照
      recoveryArr: [], //当前业务需要回收的影像
      paltformClass: "",
      initFinish: false,
      isTest: false, //测试开关
      imgClsArr: [], //所有影像类别
      collectImgItems: [], //影像上传节点
      reCollectImgItems:[],//影像补采列表
      eSignSealItems:[],//签名盖章列表
      formItemItems: [], //打印表单
      otherItem:[],//其他隐藏表单
      tabIndex: 0,
      currentNum: 0,
      isQuickCollectFlag: false,
      riskUpdateFlag:false,
      MOBILE_TEL:"",//手机号码
      ignoreImgCls: ["050","071","x9999"],
      isLoading: false,
      mergeImgClsArr: [],
    };
  },
  inject: ["hideFooter", "checkMobileLogin"],
  components: {
    flowTip,
    commonQrCode,
    uploadImg,
    sendMessage
  },
  props: [
    "bizData",
    "historyData",
    "oppBusiData",
    "qrCodeType",
    "maxApptStatus",
    "isShowNav",
    "imgType",
    "isDisabled",
    "nodeKey"
  ],
  mixins: [imgCommonMixins],
  async created () {
    // this.setData();
    let that = this;
    //根据公参配置是否显示跳过按钮
    that.isTest = await oppService.getSysCommonParamsFromCacheObjs(
      "IS_FXC_TEST"
    );
    this.initPage();
    //产品户不检查风测版本
    if(!this.$syscfg.isProOpenAcctBiz(this.busiCode)){
      this.checkRiskVersion();
    }
    // 获取合并的影像类别
    this.getMergeImgClsArr();
    if (this.apptStatus>=4) {
      this.$router.hideRoute("流程详情");
    }
    // //续办时不能删除的影像类别
    // let ignoreDelImgClsArr = (that.historyData.BUSI_COMM_PARAM.IGNORE_DEL_IMGS || "11h,050,0c2,0gr,056").split(",");
  },
  mounted () {},
  methods: {
    initPage (cb){
      let that = this;
      //隐藏bizpage的底部按钮
      this.hideFooter();
      that.$store.commit(that.$types.UPDATE_LOADING, "正在查询影像数据...");
      that.assembusiData(true, this.ignoreImgCls).then(res => {
        consoleLog("imgCollectList影像初始化完成");
        that.initFinish = true;
        that.$store.commit(that.$types.UPDATE_LOADING, false);
        that.$emit("after-load-img", that);
        cb&&cb(true);
      });
    },
    async getMergeImgClsArr () {
      let that = this;
      that.mergeImgClsArr = await that.$syscfg.K_Request("F0000107", {
        CHANNEL : "13",
      }).then(res=>{
        return _.uniqBy(_.map(res.Data , item=>{
          return item.IMG_CLS;
        })) || [];
      }).catch(err=>{
        consoleLog("获取合并影像类别失败", err.toString());
        return [];
      });
    },
    //检测客户风险测评的版本
    async checkRiskVersion () {
      //获取客户风险测评版本
      let custVersion = _.get(this, "busiInfo.BIZ_DATA.SURVEY_RESULT_LIST[0].VERSION") || "";
      let surySn = await oppService.getBusiCommonParams(this.$store.state.busicode, "PROPER_RISK_SURVEY_SN");
      //获取最新风险测评版本信息
      let resVersion = await this.$syscfg.K_Request("F0000049", {
        SURVEY_SN: surySn,
        BUSI_CODE: this.busiCode,
        USER_TYPE: this.userType 
      });
      consoleLog("获取最新风险测评版本信息", resVersion);
      let riskVersion = _.get(resVersion, "Data[0].VERSION") || "";
      if (custVersion != "" && riskVersion != "" && custVersion != riskVersion) {
        this.riskUpdateFlag = true;
        this.MOBILE_TEL = _.get(this, "historyData.BIZ_DATA.AGENT_INFO.MOBILE_TEL");
      }
    },
    //打开批量上传窗口
    openQuickCollect () {
      this.isQuickCollectFlag = true;
    },
    //提交当前获取的影像信息
    submitImg: async function (val, cb) {
      let that = this;
      let currentImgCls = val[0].IMG_CLS;
      return Promise.all([
        !this.isQuickCollectFlag ? this.photoUse(val[this.currentNum]) : this.batchPhotoUse(val[0]) 
      ]).then(res => {
        consoleLog(val[this.currentNum].IMG_CLS +"影像上传中：currentNum :" + that.currentNum +":" + "val长度:" +val.length);
        res = res[0];
        if(res.Code == "0"){
          if(!this.isQuickCollectFlag){
            //普通上传结果处理
            let resultImg = _.get(res, "Data[0]");
            if(!_.isEmpty(resultImg)){
              let imageMessage = val[this.currentNum];
              imageMessage.PAGE_NUM = resultImg.PAGE_NUM;
              imageMessage.IMG_SN = resultImg.IMG_SN;
              imageMessage.KIDM_SNO = resultImg.KIDM_SNO;
            }
            if (that.currentNum < val.length - 1) {
              consoleLog("影像上传结果，影像继续上传", resultImg);
              that.currentNum++;
              that.submitImg(val, cb);
            } else {
              consoleLog("已经上传所有的影像成功", val[this.currentNum].IMG_CLS);
              that.currentNum = 0;
              cb && cb(val);
            }
          }else{
            //批量上传
            let resultImglist = _.get(res, "Data");
            consoleLog("批量影像上传结果", resultImglist);
            // 批量采集结果
            let newResultList = []; 
            for(let i = 0; i < resultImglist.length; i++){
              let obj = resultImglist[i];
              newResultList[i] = {imgSrc: val[0].IMG_DATA_LIST[i].imgSrc, IMG_SN: obj.IMG_SN, PAGE_NUM: obj.PAGE_NUM, IMG_CLS: obj.IMG_CLS, error_msg: obj.error_msg};
            }
            cb && cb(newResultList);
          }
        }
      }).catch(err => {
        consoleError("上传图片失败,原因", err);
        this.alert("图片上传失败："+err.toString());
        this.currentNum = 0;
      });
    },
    //公共删除影像
    removeImg (params, successCallback){
      let that = this;
      this.deleteSysImg(0, params.IMG_SN, params.delList).then(res=>{
        if(res){
          let item = _.find(that.currentImgArr,obj => obj.IMG_CLS == params.IMG_CLS );
          item.IMG_DATA = _.filter(item.IMG_DATA, v=>params.delList.indexOf(v.PAGE_NUM)==-1);
          if(!item.IMG_DATA.length){
            //全删完了
            item.REVIEW_STATUS = "-1";
            item.IMG_SN = "";
            item.IMG_DATA = [];
            item.SHOW_COLLECT_TIP = "未上传";
            consoleLog("全删完了");
          }
          successCallback(true);
          // });
        }
      });
    },
    //根据影像类别获取对应影像base64数据
    getImgSrc (imgCls, filterImgSrc, cb){
      let that = this;
      that.$store.commit(that.$types.UPDATE_LOADING, "正在查询历史影像数据...");
      return that.getHistoryImgByImgCls(imgCls, filterImgSrc).then(data=>{
        consoleLog("回填历史影像");
        cb&&cb(data);
      }).catch(err => {
        consoleLog(`获取${imgCls}历史影像失败${JSON.stringify(err)}`);
        cb(false);
      });
    },
    submit: _.debounce (async function (){ 
      consoleLog("imgCollectList 提交审核");
      if(this.isLoading){
        //防止重复提交
        return;
      }
      this.isLoading = true;
      //提交流程
      try{
        //先检查流水状态，确保弱网环境，重复点击提交按钮，不会导致业务流程异常
        let oppBusiData = await oppService.getOppBusiData(this.bSno);
        //流程状态为01-受理,11-驳回的可以提交，其他状态不可以提交
        if ("01" === oppBusiData.PROC_STATUS || "11" === oppBusiData.PROC_STATUS) {
          await this.submitFlow();
        } else {
          this.$router.goNext();
          this.alert("流程已提交，请联系管理员检查业务流程数据是否正常！");
        }
        this.isLoading = false;
      }catch(err){
        this.isLoading = false;
        consoleError("提交审核失败",err);
      }

    }, 5000, {
      "leading": true,
      "trailing": false
    }),
    async submitFlow (){
      let text = this.nodeKey == "appvTask" ? "预审" : "终审";
      //终审需要校验缺章，预审不校验，与旧项目一致
      let checkNoStamp = this.nodeKey == "appvTask2";
      this.$store.commit(this.$types.UPDATE_LOADING, "正在校验..."); 
      let flag = await this.validateImg(checkNoStamp);
      if(!flag){
        return false;
      }
      //先合并一次手机端数据
      try{
        this.$store.commit(this.$types.UPDATE_LOADING, "正在更新数据..."); 
        await oppService.mergeMobileData();
      }catch(err){
        alert("提交审核失败：合并手机端数据失败!");
        consoleError("提交审核失败：合并手机端数据失败!", err);
        return false;
      }
      //保存提交预审时间
      let params = {
        APPT_SN: this.apptSn,
      };
      let reqService = "";
      if (this.nodeKey == "appvTask") {
        // 发起预审
        params.PRETRIALREVIEWDATE = date.getClientDateTime("yyyy-MM-dd hh:mm:ss");
        reqService = "P001003651"; 
      } else if (this.nodeKey == "appvTask2") {
        //发起终审
        params.FINALREVIEWDATE = date.getClientDateTime("yyyy-MM-dd hh:mm:ss");
        reqService = "P001003652"; 
        //发起终审前，先判断是否需要用印电子化， 如果有需要则收集影像类别，并调用用印电子化接口
        let needCls = [];
        this.formItemItems.filter(v=>{
          if(v.IS_E_SEAL=="1"&& ["0","1","4"].includes(v.REVIEW_STATUS)){
            needCls.push(v.IMG_CLS);
          }
        });
        consoleLog("需要用印电子化的类别", needCls);
        if(needCls.length){
          this.$store.commit(this.$types.UPDATE_LOADING, "正在合成表单..."); 
          let flag = await this.agreement({
            KIDM_SNO: this.busiData.KIDM_SNO,
            BUSI_CODE: this.busiData.BUSI_CODE,
            IMG_CLSS:needCls.join(","),
            CHANNEL: "13",
            USER_TYPE: this.busiData.USER_TYPE,
            SYS_CODE: "99",
            ORG_CODE: this.busiData.ORG_CODE,
            FILE_STATUS: "1",
            IS_SHOW_ERROR: "0",
            IMG_FMT: "3",
          });
          if(!flag){
            alert("发起终审失败,表单合成失败！");
            return false;
          }
        }
        //OPPCP-38320 开户业务：开户业务节点在见证节点之前就创建了(流程图里只有开户业务节点无见证节点，旧项目也是这个流程图)，为了让开户业务节点显示在见证节点之后，
        //需要发起终审之后更新开户业务的操作时间,业务受理节点nodekey为空
        this.nodeKey == "appvTask2" && await oppService.updateFinallyTaskTime(this.bSno, "").catch(err=>{
          alert("更新节点时间失败"+err.toString());
          consoleError("更新节点时间失败"+err.toString());
          return false;
        });
      }
      this.$store.commit(this.$types.UPDATE_LOADING, "正在提交" + text);   
      //更新node_code
      await oppService.saveBizData();    
      //保存DATA_EXT表
      return this.$syscfg.K_Request("F0000069", params).then(async res => {
        consoleLog("发起审核，保存dataext表结果", res);
        // 发起预审核流程
        return this.$syscfg.K_Request(reqService, {
          B_SNO: this.bSno,
          openAccType: this.userType == "1" ? "2" : "3",
          BUSI_CODE: this.busiCode,
          USER_TYPE: this.userType,
          CUST_FNAME: this.custInfo.CUST_FNAME,
          CUST_NAME: this.custInfo.CUST_NAME,
          ID_TYPE: this.custInfo.ID_TYPE,
          ID_CODE: this.custInfo.ID_CODE,
          YZT_CHANNEL: "13",
          CUST_CODE: "0",
          OP_CODE: this.userInfo.OP_CODE,
          ORG_CODE: this.userInfo.ORG_CODE,
          USER_ID: this.userInfo.USER_CODE
        }).then(async res => {
          consoleLog("发起预审核流程结果", res);
          if (res.Code == "0"){
            //更新OPP_appt_data 预约表流程状态为 影像上传节点变为2-预审中， 表单上传节点为11-审核中
            return oppService.updateApptStatus(this.$store.state.apptSn, this.imgType == "uploadImg" ? "2" : "11")
              .then(async () => {
                this.$store.commit(this.$types.UPDATE_APPT_STATUS, this.imgType == "uploadImg" ? "2" : "11"); 
                this.$storage.setSession(
                  this.$definecfg.APPT_STATUS,
                  this.imgType == "uploadImg" ? "2" : "11"
                );
                this.$store.commit(this.$types.UPDATE_LOADING, false); 
                await this.saveKidmImgclsCollectFlag();
                this.$router.goNext();
              });
          }else{
            alert(`提交${text}失败:${res.Msg}`);
            return false;
          }
        });
      }).finally(()=>{
        this.$store.commit(this.$types.UPDATE_LOADING, false); 
      });
    },
    agreement (params){
      return saveAgreement(params).then(async res => {
        return true;
      }).catch(err=>{
        return false;
      });
    },  
    async validate () {
      return true;
    },
    async  goPrev (){
      consoleLog("imgCollectList goPrev");
      await this.saveKidmImgclsCollectFlag();
      this.$router.goPrev();
    },
    async skipToNext () {
      await this.saveKidmImgclsCollectFlag();
      //下一步仅更新nodecode
      return oppService.updateNodeCode().then(()=>{
        this.$router.goNext();
      });
    },
    async saveKidmImgclsCollectFlag (){
      //上一步，下一步，还有提交审核的时候，都要去调用这个接口
      await saveKidmImgclsCollectFlag(this, this.currentImgArr);
    }
  },
  computed: {
    busiCode () {
      return this.$store.state.busicode;
    },
    userType () {
      return this.$store.state.usertype;
    },
    busiName () {
      return this.$store.state.busiName;
    },
    bSno () {
      return this.$storage.getSession(this.$definecfg.B_SNO);
    },
    apptSn () {
      return this.$store.state.apptSn;
    },
    apptStatus () {
      return this.$store.state.apptStatus;
    },
    isShowPrev: function () { // 控制是否显示上一步
      return this.$router.getCurrentRouteIndex() > this.$blMethod.getFirstWithIgnorePageIndex(this);
    },
    unknowImg (){
      let unkonwImgArr = this.eSignSealItems.filter(val => {
        return val.IMG_CLS === "x9999";
      });
      return unkonwImgArr[0] || {};
    },
    currentImgArr: {
      get: function () {
        //影像上传
        if(this.imgType=="uploadImg"){
          return this.collectImgItems;
        }else if(this.imgType=="uploadForm"){
          //表单上传  0-影像补传 1-签名盖章表单
          return this.tabIndex == 0 ? this.reCollectImgItems : this.eSignSealItems;
        }else{
          return [];
        }
      },
      set: function (newValue) {
        //影像上传
        if(this.imgType=="uploadImg"){
          this.collectImgItems = newValue;
        }else if(this.imgType=="uploadForm"){
          if (this.tabIndex == 0) {
            this.reCollectImgItems = newValue;
          } else {
            this.formItemItems = newValue;
          }
        }else{
          return [];
        }
       
      }
    },
    pageReload (){
      return this.$store.state.pageReload;
    },
  },
  watch: {
    currentIndex: {
      handler (index) {},
      immediate: true
    },
    pageReload (newValue, oldValue){
      console.error("reloadPage变更了", newValue);
      if(newValue){
        this.saveKidmImgclsCollectFlag();
      }
    },
    unknowImg (v){
      //自动分类弹窗
      //1存在未识别影像，且当前未展示分类窗口，未展示上传窗口，
      //未正在加载分类图片，已关闭快速采集窗口，且当前未上传表单节点才展示弹窗
      setTimeout(()=>{
        let uploadRef = this.$refs.uploadContent || {};
        if(_.get(v, "IMG_DATA.length")&&!uploadRef.isShowDrag&&!uploadRef.isShowBox
          && uploadRef.isloadingImg===false && !this.isQuickCollectFlag && this.imgType=="uploadForm"){
          this.tabIndex = 1;
          if(this.$store.state.mobileLogin){
            let that = this;
            this.alert(
              {
                messageText:"检测到存在未分类表单，请退出手机登录后进行表单分类",
                confirmedAction:async ()=>{
                  uploadRef.isloadingImg = true;
                  //调用接口 退出手机登录
                  await that.$syscfg.K_Request("F0000080", {});
                  //立刻触发手机登录检查
                  that.checkMobileLogin();
                  uploadRef.openDragBox();
                },
                confirmButtonText: "退出手机登录",
              });
          }else{
            this.alert(
              {
                messageText:"检测到存在未分类表单，请进行表单分类",
                confirmedAction:()=>{
                  uploadRef.isloadingImg = true;
                  uploadRef.openDragBox();
                }
              });
          }
        }
      }, 1000);
    },
  }
};
</script>

<style lang="less" scoped>
.imgCollectList {
  width: 100%;
  height: 100%;
  position: relative;
  .collectContent{
    padding: 20px;
    background: #ffffff;
    border-radius: 5px;
    margin-top: 2px;
    .uploadContent{
      padding-left: 5%;
    }
    .tabs {
      display: flex;
      height: 0.5rem;
      font-size: 18px;
      background: #f6f7f9;
      margin-bottom: 0.24rem;
      line-height: 0.5rem;
      position: relative;
      .tab {
        margin: 0 0.4rem;
        cursor: pointer;
      }
      .tab.on {
        border-bottom: 2px solid #cfa972;
        color: #cfa972;
      }
      .quickAdd {
        position: absolute;
        right: 20px;
        top: 0;
        margin: 0;
        color: #cfa972;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/imageNode/imgCollectList.vue